import { colors } from '@globals/themes/defaultTheme'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import NumberField from '@shared/forms/NumberField'
import PointsEstimateDisplay from '@tenant/recognition/RecognitionModal/sendRecognitionView/PointsEstimateDisplay'
import usePointsSelection from '@tenant/recognition/RecognitionModal/sendRecognitionView/usePointsSelection'
import { T } from '@transifex/react'

const MobileRecognitionPointsView = () => {
  const {
    canSendPoints,
    points,
    allowCustomPoints,
    isLoadingPresets,
    amount,
    onAmountChange,
    isUsingCustomAmount,
    disabledValues,
    handleFixedSelection,
    openCustomSelection,
    allocationPoints,
    handleRecipientCountChange,
    handleAllocationPointsChange,
    sendTo,
    control,
  } = usePointsSelection({})

  if (!canSendPoints) return null

  if (isLoadingPresets) {
    return (
      <Box
        sx={{
          pb: 2,
        }}>
        <Stack
          useFlexGap
          direction="row"
          spacing={1}
          sx={{
            flexWrap: 'wrap',
          }}>
          {Array.from(new Array(5)).map((_, value) => (
            <Skeleton variant="circular" key={value} width={42} height={36} />
          ))}
        </Stack>
      </Box>
    )
  }

  return (
    <Stack
      useFlexGap
      sx={{
        gap: 1.5,
      }}>
      <Box
        sx={{
          pb: 2,
        }}>
        <Stack
          useFlexGap
          direction="row"
          spacing={0.5}
          sx={{
            flexWrap: 'wrap',
          }}>
          {points.map(p => (
            <Tooltip
              id={`tooltipkChip-mobile-${p.id}`}
              key={p.id}
              title={disabledValues?.includes(p.id) ? <T _str="Not enough points" /> : null}
              placement="top">
              <Stack>
                <Chip
                  id={`pointsAmountChip-mobile-${p.id}`}
                  aria-labelledby={`tooltipChip-mobile-${p.id}`}
                  label={p.label}
                  variant={amount === parseInt(p.id, 10) ? 'baseSelected' : 'baseUnselected'}
                  disabled={disabledValues?.includes(p.id) ?? false}
                  onClick={() => handleFixedSelection(parseInt(p.id, 10))}
                />
              </Stack>
            </Tooltip>
          ))}
          {allowCustomPoints && (
            <Chip
              id="pointsAmountChip-mobile-other"
              label="Other"
              variant={isUsingCustomAmount ? 'baseSelected' : 'baseUnselected'}
              disabled={allocationPoints === 0}
              onClick={openCustomSelection}
            />
          )}
        </Stack>
      </Box>
      {isUsingCustomAmount && allowCustomPoints && (
        <Stack
          sx={{
            mb: 1,
          }}>
          <NumberField
            fullWidth
            control={control}
            name="amount"
            label={<T _str="Custom point amount" />}
            labelStyle={{ mt: 0 }}
            decimalScale={0}
            value={amount || ''}
            onChange={event => onAmountChange(parseInt(event.target.value, 10) || 0)}
          />
        </Stack>
      )}
      <PointsEstimateDisplay
        amount={amount}
        sendTo={sendTo}
        onRecipientCountChange={handleRecipientCountChange}
        onAllocationPointsChange={handleAllocationPointsChange}
        backgroundColor={colors.white}
      />
    </Stack>
  )
}

export default MobileRecognitionPointsView
